// extracted by mini-css-extract-plugin
export var locationsContainer = "_zp-2";
export var locationsTextContainer = "_zp-1";
export var mapContainer = "_zp-0";